import { Injectable } from '@angular/core';
import {fromEvent, merge, Subject} from "rxjs";
import {CesiumAdapterService} from "@src/app/services/cesiumAdapter21/cesium-adapter.service";
import {filter} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class MouseListenersService {

  private _mouseMove$ = new Subject<Event>();
  get mouseMove$(){
    return this._mouseMove$.asObservable();
  }

  constructor() {
    this.initListeners();
  }

  private initListeners(){
    var mouseMove$ = fromEvent(document, 'pointermove');
    mouseMove$.subscribe((event)=>{
      this._mouseMove$.next(event);
    })
  }

}
